module.exports = "<ubi-layout-detail (save)=\"save($event)\" (delete)=\"delete($event)\" (cancel)=\"cancel($event)\" [status]=\"status\">\n\n    <div detail-content class=\"dynamic-form\">\n\n        <dynamic-form [config]=\"config\" [options]=\"options\" #form=\"dynamicForm\">\n        </dynamic-form>\n\n        <div class=\"row\">\n            <span>{{error}}</span>\n        </div>\n    </div>\n\n</ubi-layout-detail>"


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-entity/components/dynamic-detail/dynamic-detail.component.html
// module id = ../../../../../src/app/dynamic-entity/components/dynamic-detail/dynamic-detail.component.html
// module chunks = main